module.exports = __webpack_public_path__ + "static/img/dn3-mayor.3465394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn3-mayor.png
// module id = hitp
// module chunks = 0